<template>
    <div class="bg-gray-100 mx-auto md:w-3/5">
      <section>
        <section class="text-gray-600 body-font">
          <div class="container p-5 mx-auto">
            <div class="px-5 my-2 bg-white flex items-center mx-auto border-b border-gray-200 rounded-lg sm:flex-row flex-col">
              <div class="sm:w-32 sm:h-32 h-20 w-20 sm:mr-10 inline-flex items-center justify-center flex-shrink-0">
                <img class="rounded-md"
                  :src="projectImage"
                  alt="Project Logo"
                />
              </div>
              <div class="flex-grow sm:text-left text-center mt-6 sm:mt-0">
                <h1 class="text-black text-2xl title-font font-bold mb-2">{{ projectName }}</h1>
                <p class="leading-relaxed text-base">{{ projectDescription }}</p>
                <div class="py-4">
                  <div v-for="technology in projectTechnologies" :key="technology" class="inline-block mr-2">
                    <div class="flex pr-2 h-full items-center">
                      <svg class="text-yellow-500 w-6 h-6 mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z"/>
                        <circle cx="12" cy="12" r="9"/>
                        <path d="M9 12l2 2l4 -4"/>
                      </svg>
                      <p class="title-font font-medium">{{ technology }}</p>
                    </div>
                  </div>
                </div>
                <a v-if="projectLink" :href="projectLink" class="mt-3 text-indigo-500 inline-flex items-center" target="_blank">
                  <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                  </svg>
                  {{ projectLink }}
                </a>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ComponentCard',
    props: {
      projectName: String,
      projectDescription: String,
      projectTechnologies: Array,
      projectLink: String,
      projectImage: String,
    }
  }
  </script>
  
  <style scoped>
  </style>
  